import { type ReactNode } from 'react';

import { RemixiconComponentType, RiToolsLine } from '@remixicon/react';

import { ModuleIcons } from '@spotify/confidence-core-react';

import { ToolGroupEntry } from '../../extensions/tool-extension';
import { renderInlineMarkdownLinks } from '../../utils/inlineMarkdownLinks';

export const DEFAULT_TOOL_ICON = RiToolsLine;

const TOOL_ICON_KEYWORDS: Array<{
  keywords: string[];
  icon: RemixiconComponentType;
}> = [
  {
    keywords: ['flag', 'targeting_rule'],
    icon: ModuleIcons.flags,
  },
  {
    keywords: ['abtest', 'ab_test', 'experiment'],
    icon: ModuleIcons.abtests,
  },
  {
    keywords: ['metric', 'measurement'],
    icon: ModuleIcons.metrics,
  },
  { keywords: ['segment'], icon: ModuleIcons.segments },
  { keywords: ['event'], icon: ModuleIcons.events },
  { keywords: ['rollout'], icon: ModuleIcons.rollouts },
  {
    keywords: ['analysis', 'analyze'],
    icon: ModuleIcons.analysis,
  },
  { keywords: ['surface'], icon: ModuleIcons.surfaces },
];

export const inferToolIcon = (toolName: string): RemixiconComponentType => {
  const lower = toolName.toLowerCase();
  const match = TOOL_ICON_KEYWORDS.find(({ keywords }) =>
    keywords.some(kw => lower.includes(kw)),
  );
  return match?.icon ?? DEFAULT_TOOL_ICON;
};

export const formatDefaultToolLabel = (
  entry: ToolGroupEntry,
): { text: ReactNode; detail?: string } => {
  return {
    text: renderInlineMarkdownLinks(
      entry.displayName ?? entry.tool.replace(/_/g, ' '),
    ),
  };
};
